var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"c-m-mypages-menu"},[_c('div',{staticClass:"c-m-mypages-menu__list",attrs:{"id":"mypages-menu__list"}},_vm._l((_vm.routes),function(route,index){return _c('router-link',{key:index,staticClass:"c-m-mypages-menu__item",attrs:{"to":{name: route.name}}},[_c('icon',{attrs:{"icon":_vm.setIcon(route)}}),_vm._v(" "),_c('span',{staticClass:"c-m-mypages-menu__name"},[_vm._v(_vm._s(route.name))])],1)}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4622d037","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/molecules/MoleculeMyPagesMenu.vue
// module id = 1328
// module chunks = 0